import { auth } from "@/lib/picasso-firebase";
import { getVideoLastFrame, getVideoForDownload } from "@/api/videoApi";

/**
 * Download a video file from backend using video ID
 * @param videoId - The ID of the video to download
 * @param filename - The filename for the downloaded video
 */
export const downloadVideoFromUrl = async (videoId: string, filename: string): Promise<void> => {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      alert("Authentication required");
      return;
    }

    const videoBlob = await getVideoForDownload(videoId);
    
    if (!videoBlob) {
      throw new Error("No video data received from server");
    }
    
    const url = globalThis.URL.createObjectURL(videoBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    globalThis.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Failed to download video:", error);
    alert("Failed to download video. Please try again.");
  }
};

/**
 * Download the last frame of a video using signed URL (for admin use)
 * @param signedUrl - The signed URL of the video
 */
export const downloadLastFrameFromUrl = async (signedUrl: string): Promise<void> => {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      alert("Authentication required");
      return;
    }

    // Use centralized API function to get the last frame
    const lastFrameBase64 = await getVideoLastFrame(signedUrl);
    
    if (!lastFrameBase64) {
      throw new Error("No frame data received from server");
    }
    
    // Convert base64 to blob for download
    const byteCharacters = atob(lastFrameBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.codePointAt(i) ?? 0;
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/jpeg' });
    
    const url = globalThis.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "last_frame.jpg";
    document.body.appendChild(a);
    a.click();
    a.remove();
    globalThis.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Failed to download last frame:", error);
    alert("Failed to download last frame. Please try again.");
  }
};
